import { useEffect } from 'react';
import { useAuthFrontLock } from '../../../context/useAuthFrontContext';
import { ConnectionNamesEnum } from '@cimpress-technology/authfront-lock-sdk';
import { PAGE_NAME, SocialAuthPageName } from '../../../utils/constant/constant';
import { useScreen } from '../../../context/useScreen';
import { useLoader } from '../../../context/useLoader';

type ProviderMap = {
    [SocialAuthPageName.GOOGLE]: typeof ConnectionNamesEnum.GOOGLE;
    [SocialAuthPageName.FACEBOOK]: typeof ConnectionNamesEnum.FACEBOOK;
    [SocialAuthPageName.APPLE]: typeof ConnectionNamesEnum.APPLE;
};

const providerMap: ProviderMap = {
    [SocialAuthPageName.GOOGLE]: ConnectionNamesEnum.GOOGLE,
    [SocialAuthPageName.FACEBOOK]: ConnectionNamesEnum.FACEBOOK,
    [SocialAuthPageName.APPLE]: ConnectionNamesEnum.APPLE
};

type SocialAuthPageProps = {
    provider: SocialAuthPageName
}

const SocialAuthPage: React.FC<SocialAuthPageProps> = ({ provider }) => {
    const authFrontLock = useAuthFrontLock();
    const { setDisplayScreen } = useScreen();
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        try {
            showLoader();
            const socialProvider = providerMap[provider];
            authFrontLock.authorizeSocial({ provider: socialProvider });
        } catch (err: unknown) {
            setDisplayScreen(PAGE_NAME.SIGN_IN);
            hideLoader();
        }
    }, []);

    return null;
};

export default SocialAuthPage;
